export const typographyTokens = {
  'font-family': "'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
  'font-family-mono': "'Cascadia Code', 'Fira Code', 'Consolas', monospace",
  'font-size-xs': '11px',
  'font-size-sm': '12px',
  'font-size-md': '14px',
  'font-size-lg': '16px',
  'font-size-xl': '20px',
  'font-size-2xl': '24px',
  'font-size-3xl': '32px',
  'font-weight-normal': '400',
  'font-weight-medium': '500',
  'font-weight-semibold': '600',
  'font-weight-bold': '700',
  'line-height-tight': '1.25',
  'line-height-normal': '1.5',
  'line-height-relaxed': '1.75',
  'letter-spacing-tight': '-0.02em',
  'letter-spacing-normal': '0',
  'letter-spacing-wide': '0.05em',
} as const;

export type TypographyTokens = typeof typographyTokens;
